import { Component, Input, SimpleChanges } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { DevanManagementService } from '../../../../../../../shared/Container/devan/devan-management.service';
import { DevanType } from '../../../../../../../shared/Container/devan/models/DevanType';
import { AsyncPipe, CommonModule } from '@angular/common';
import { NgSelectComponent } from '@ng-select/ng-select';
import { CustomDateRangePickerComponent } from '../../../../../../../shared/components/custom-date-range-picker/custom-date-range-picker.component';

@Component({
  selector: 'app-container-job-pack-properties',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AsyncPipe, NgSelectComponent, CustomDateRangePickerComponent],
  templateUrl: './container-job-pack-properties.component.html',
  styleUrl: './container-job-pack-properties.component.scss'
})
export class ContainerJobPackPropertiesComponent {
  @Input()
  formGroup!: FormGroup;

  // Lookups
  availablePackTypes$: Observable<DevanType[]>;

  constructor(private devanManagementService: DevanManagementService) {
    this.availablePackTypes$ = this.devanManagementService.getDevanType(true, false, true);
  }

  getFormPartial = (formPath: string) => this.formGroup.get(formPath) as FormControl;
  
  ngOnChanges(changes: SimpleChanges) {
    if (changes['formGroup']) {
      this.formGroup.patchValue(changes['formGroup'], { emitEvent: false });
    }
  }
}
